// extracted by mini-css-extract-plugin
export default {"experience":"experience_experience__wumzG","tiles":"experience_tiles__FxUHW"};